import { render, staticRenderFns } from "./patrol.vue?vue&type=template&id=0b5b4ce7"
import script from "./patrol.vue?vue&type=script&lang=js"
export * from "./patrol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b5b4ce7')) {
      api.createRecord('0b5b4ce7', component.options)
    } else {
      api.reload('0b5b4ce7', component.options)
    }
    module.hot.accept("./patrol.vue?vue&type=template&id=0b5b4ce7", function () {
      api.rerender('0b5b4ce7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/patrol/patrol.vue"
export default component.exports